export default function ContactFooter() {
  return (
    <footer className="contact-footer" id="contact">
      <div>
        <p className="mono-label">Inquiry / collaboration / editorial work</p>
        <h2>Wenn ein Bild nicht nur funktionieren, sondern nachhallen soll.</h2>
      </div>
      <a href="mailto:hello@stefanmaldet.de">hello@stefanmaldet.de</a>
      <p>Stefan Maldet / Photography / Visual Direction</p>
    </footer>
  );
}
